import { Input, Form, Select, DatePicker, Switch } from "antd";
import { TextInputProps } from "@/types";

const { Search } = Input;
const { RangePicker } = DatePicker;

const TextInput = ({
	name,
	label,
	rules,
	disabled,
	type,
	options,
	placeholder,
	handleSearch,
	mode,
	showSearch,
	loading,
}: TextInputProps) => {
	const inputType: { [index: string]: React.ReactNode } = {
		search: <Search disabled={disabled} placeholder={placeholder} />,
		text: <Input disabled={disabled} placeholder={placeholder} />,
		select: (
			<Select
				disabled={disabled}
				options={options}
				onSearch={handleSearch}
				showSearch={showSearch}
				optionFilterProp="label"
				optionLabelProp="label"
				mode={mode}
				placeholder={placeholder}
				loading={loading}
				maxTagCount="responsive"
				allowClear
			/>
		),
		rangepicker: <RangePicker style={{ width: "100%" }} disabled={disabled} />,
		switch: <Switch disabled={disabled} />,
	};

	return (
		<Form.Item name={name} label={label} rules={rules}>
			{inputType[type]}
		</Form.Item>
	);
};

export default TextInput;
